export default {
  inputPlaceholder: '请输入消息...',
  send: '发送',
  layout: {
    search: '搜索',
    tabs: {
      all: '全部',
      private: '私信对话',
      group: '群聊对话'
    },
    user: {
      info: '用户信息',
      online: '在线',
      lastLogin: '最近登录',
      email: '邮箱'
    },
    material: {
      library: '素材库',
      image: {
        title: '素材1.png'
      },
      document: {
        title: '报告.docx'
      },
      video: {
        title: '演示视频.mp4'
      },
      audio: {
        title: '音频文件.mp3'
      }
    }
  }
}
